import { writable } from 'svelte/store'
import { preferences } from './preferences.js'

export const init = {
  apiUrl: preferences.apiUrl,
  layers: [],
  attributes: [],
  data: [],
  dataset: undefined,
  datasets: { _status: 'init' },
  metadata: {},
  rowsLimit: preferences.rowsLimit,
  view: 'gridify', // config, gridify
}

export const apiUrl = writable(init['apiUrl'])
export const attributes = writable(init['attributes'])
export const data = writable(init['data'])
export const dataset = writable(init['dataset'])
export const datasets = writable(init['datasets'])
export const layers = writable(init['layers'])
export const metadata = writable(init['metadata'])
export const rowsLimit = writable(init['rowsLimit'])
export const view = writable(init['view'])
